import { render } from "./BlogGridSection.vue?vue&type=template&id=7453df69"
import script from "./BlogGridSection.vue?vue&type=script&lang=js"
export * from "./BlogGridSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__